export default "__VITE_ASSET__b1541d1f__"